import {
  FETCH_SELENIUM_LOGS_LOADING,
  FETCH_SELENIUM_LOGS_SUCCESS,
  FETCH_SELENIUM_LOGS_FAILED,
  CLEAR_SELENIUM_LOGS
} from "../../actionTypeConstants/ml2.0/SeleniumLogs";
import get from "lodash/get";

const initialState = {
  data: "",
  url: "",
  loading: true,
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_SELENIUM_LOGS_LOADING: {
      return {
        ...state,
        loading: true,
        data: "",
        error: null
      };
    }

    case FETCH_SELENIUM_LOGS_SUCCESS: {
      const fetchFromLTMA = get(
        action,
        ["payload", "areLogsFetchedFromLTMA"],
        false
      );
      const url = get(action, ["result", "config", "url"], "");
      return {
        ...state,
        loading: false,
        url,
        data: fetchFromLTMA
          ? get(action, ["result", "data"], "")
          : get(action, ["result", "data", "data"], ""),
        error: null
      };
    }

    case FETCH_SELENIUM_LOGS_FAILED: {
      return {
        ...state,
        loading: false,
        data: "",
        error: action.error.response
      };
    }

    case CLEAR_SELENIUM_LOGS: {
      return {
        ...state,
        loading: false,
        data: "",
        error: null
      };
    }

    default: {
      return state;
    }
  }
}
